var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/social/twitter-share.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg viewBox=\"0 0 95 95\" class=\"c-social__twitter\" aria-labelledby=\"twitter-share-svg-title\" xmlns=\"http://www.w3.org/2000/svg\">\n    <title id=\"twitter-share-svg-title\">\n        ";
output += runtime.suppressValue((lineno = 2, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["social-twitter"])), env.opts.autoescape);
output += "\n    </title>\n    <path d=\"M47.5 0C21.3 0 0 21.3 0 47.5S21.3 95 47.5 95 95 73.7 95 47.5 73.7 0 47.5 0zM67 37.4v1.3C67 52 56.9 67.4 38.3 67.4c-5.7 0-11-1.6-15.5-4.5.8 0 1.6.1 2.4.1 4.7 0 9-1.6 12.5-4.3-4.4-.1-8.1-3-9.4-7 .6.1 1.3.2 1.9.2 1 0 1.9-.2 2.7-.4-4.6-.9-8.1-5-8.1-9.9v-.1c1.4.8 2.9 1.2 4.6 1.3-2.7-1.8-4.5-4.9-4.5-8.4 0-1.9.5-3.6 1.4-5.1 5 6.1 12.4 10.1 20.8 10.5-.2-.7-.3-1.5-.3-2.3 0-5.6 4.5-10.1 10.1-10.1 2.9 0 5.6 1.2 7.4 3.2 2.3-.4 4.4-1.2 6.4-2.4-.7 2.4-2.3 4.4-4.4 5.6 2-.3 4-.8 5.8-1.6-1.3 2-3.1 3.8-5.1 5.2z\"></path>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/social/twitter-share.j2"] , dependencies)